import * as React from 'react';
import { IRelatedFilter } from '../redux/modules/document';

const NOTE_COLORS = ['color1', 'color2', 'color3', 'color4', 'color5'];

interface IRelatedMaterialFilterProps {
    notesCount: number;
    coursesCount: number;
    filter: IRelatedFilter;
    onChange: (filter: IRelatedFilter) => void;
    onClose: () => void;
    className?: string;
}

// Filtreringspanel för "Relaterat material" (Figma node 19668:45772). Fälls ut från
// Filtrera-knappen i headern (desktop-panelen och mobil-modalens header). OCH-logik
// mellan de tre filtertyperna hanteras i modules/helpers/relatedFilter.ts.
export default function RelatedMaterialFilter({ notesCount, coursesCount, filter, onChange, onClose, className }: IRelatedMaterialFilterProps) {
    const toggleType = (type: string) => {
        const types = filter.types.includes(type)
            ? filter.types.filter(t => t !== type)
            : [...filter.types, type];
        onChange({ ...filter, types });
    };

    const toggleColor = (color: string) => {
        const colors = filter.colors.includes(color)
            ? filter.colors.filter(c => c !== color)
            : [...filter.colors, color];
        onChange({ ...filter, colors });
    };

    const setQuery = (query: string) => {
        onChange({ ...filter, query });
    };

    return (
        <div className={`related-filter ${className || ''}`} role="dialog" aria-label="Filtrera relaterat material">
            <div className="related-filter__section">
                <p className="related-filter__label">Typ</p>
                <label className="related-filter__checkbox">
                    <input
                        type="checkbox"
                        checked={filter.types.includes('notes')}
                        onChange={() => toggleType('notes')}
                    />
                    <span>Anteckningar ({notesCount})</span>
                </label>
                <label className="related-filter__checkbox">
                    <input
                        type="checkbox"
                        checked={filter.types.includes('courses')}
                        onChange={() => toggleType('courses')}
                    />
                    <span>Relaterade kurser ({coursesCount})</span>
                </label>
            </div>

            <div className="related-filter__section">
                <p className="related-filter__label">Markeringsfärg</p>
                <div className="related-filter__colors">
                    {NOTE_COLORS.map(color => (
                        <button
                            type="button"
                            key={color}
                            className={`related-filter__color ${filter.colors.includes(color) ? 'related-filter__color--selected' : ''}`}
                            aria-label={color}
                            aria-pressed={filter.colors.includes(color)}
                            onClick={() => toggleColor(color)}
                        >
                            <span className={`related-filter__color-swatch related-filter__color-swatch--${color}`} aria-hidden="true"></span>
                        </button>
                    ))}
                </div>
            </div>

            {/* Sökfältet ska ligga sist, under Typ och Markeringsfärg (Figma node 19668:45772). */}
            <div className="related-filter__search">
                <span className="related-filter__search-icon" aria-hidden="true"></span>
                <input
                    type="text"
                    className="related-filter__search-input"
                    placeholder="Sök bland relaterat material"
                    value={filter.query}
                    onChange={(e) => setQuery(e.target.value)}
                />
            </div>
        </div>
    );
}
